import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"counsel_todo",
    list_id:"make_counsel_todo_write_list",
    x_column_list_arr:[
      {"key":"a_reserve_date","name":"예정일","width":"90","is_show":"1"},
      // {"key":"a_sort1","name":"구분","width":"70","is_show":""},
      // {"key":"a_sort2","name":"구분","width":"70","is_show":""},
      {"key":"a_stu_name","name":"학생명","width":"80","is_show":"1"},
      {"key":"a_counseler","name":"상담자","width":"80","is_show":"1"},
      //{"key":"a_title","name":"제목","width":"80","is_show":"1"},
      {"key":"a_state","name":"상태","width":"80","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':10,
      'order_id':'',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);
  xColumnArr.number_col_arr=[];

  return xColumnArr;
};

export default getXcolumnJson;